const TableRow = ({
  children,
  type = "row",
}: {
  children: React.ReactNode;
  type?: string;
}) => {
  return (
    <tr
      data-head={type === "head"}
      className="text-left data-[head=true]:sticky data-[head=true]:bg-offWhite data-[head=true]:z-10
       bg-white top-0 data-[head=false]:border-b border-extraLightGray/80"
    >
      {children}
    </tr>
  );
};

const TableCell = ({
  type = "td",
  children,
  className,
}: {
  children: React.ReactNode;
  type: React.ElementType;
  className?: string;
}) => {
  const Component = type;
  return (
    <Component
      className={`px-4 flex-1 text-sm h-10  ${className}
        ${
          type === "th"
            ? "font-semibold text-subHeading first:rounded-l-lg last:rounded-r-lg"
            : "font-semibold text-heading "
        }`}
    >
      {children}
    </Component>
  );
};

export { TableRow, TableCell };
